import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { useAuth } from "../context/AuthContextProvider";
import {
  getBusinessTypes,
  requestLive,
} from "../services/merchant";
import toast from "react-hot-toast";
import { verifyAccount } from "../services/settings";

function MigrateModal() {
  const { setIsModalOpen } = useAuth();
  const [businessType, setBusinessType] = useState("");
  const [businessTypes, setBusinessTypes] = useState([]);
  const [testWebAddress, setTestWebAddress] = useState("");
  const [businessWebAddress, setBusinessWebAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [migrateLoading, setMigrateLoading] = useState(false);

  const fetchBusinessType = async () => {
    try {
      const res = await getBusinessTypes();
      setBusinessTypes(res.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    fetchBusinessType();
  }, []);

  const handleVerify = async (value) => {
    setLoading(true);
    try {
      const res = await verifyAccount({
        bankCode: "800",
        accountNumber: value,
      });
      setLoading(false);
      setAccountName(res.data.beneficiaryName);
    } catch (error) {
      if (error.response) {
        setLoading(false);
        setAccountName("Account name not found");
      }
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;

    // Ensure the value is numeric and has at most 10 digits
    if (/^\d{0,10}$/.test(value)) {
      setAccountNumber(value);

      if (value.length === 10) {
        handleVerify(value);
      } else {
        // Clear the account name if input is not exactly 10 digits
        setAccountName("");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMigrateLoading(true);
    const payload = {
      businessType,
      testWebAddress,
      businessWebAddress,
      accountNumber,
      accountName,
      bankCode: "800",
    };
    const payload2 = {
      businessType,
      testWebAddress,
      businessWebAddress,
    };
    try {
      const response = await requestLive(accountNumber ? payload : payload2);
      toast.success(response.message);
      setMigrateLoading(false);
      setIsModalOpen(false);
    } catch (error) {
      if (error.response) {
        setMigrateLoading(false);
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <Dialog
      visible={true}
      onHide={() => setIsModalOpen(false)}
      header="Request Live Account"
      style={{ width: "450px", maxWidth: "95vw" }}
      dismissableMask
      draggable={false}
      resizable={false}
    >
      <form className="flex flex-col gap-4 text-sm pt-2" onSubmit={handleSubmit}>
        <div className="flex flex-col">
          <label htmlFor="testWebAddress" className="font-medium text-gray-700 mb-1">
            Test Web Address:
          </label>
          <input
            type="text"
            id="testWebAddress"
            name="testWebAddress"
            onChange={(e) => setTestWebAddress(e.target.value)}
            className="w-full h-[40px] bg-gray-50 border border-gray-200 outline-none rounded-md px-3 text-sm focus:border-primary"
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="businessWebAddress" className="font-medium text-gray-700 mb-1">
            Business Web Address:
          </label>
          <input
            type="text"
            id="businessWebAddress"
            name="businessWebAddress"
            onChange={(e) => setBusinessWebAddress(e.target.value)}
            className="w-full h-[40px] bg-gray-50 border border-gray-200 outline-none rounded-md px-3 text-sm focus:border-primary"
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="businessType" className="font-medium text-gray-700 mb-1">
            Select business type:
          </label>
          <select
            id="businessType"
            name="options"
            value={businessType}
            onChange={(e) => setBusinessType(e.target.value)}
            className="h-[40px] bg-gray-50 border border-gray-200 px-3 rounded-md text-navy-blue focus:outline-none focus:border-primary text-sm"
          >
            <option value="">Select Business Type</option>
            {businessTypes.map((business) => (
              <option key={business.id} value={business.code}>
                {business.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col">
          <label htmlFor="accountNumber" className="font-medium text-gray-700 mb-1">
            Enter Hope Account Number (Optional)
          </label>
          <input
            type="text"
            id="accountNumber"
            name="accountNumber"
            value={accountNumber}
            onChange={handleChange}
            placeholder="10-digit account number"
            className="w-full h-[40px] bg-gray-50 border border-gray-200 outline-none rounded-md px-3 text-sm focus:border-primary"
          />
          {loading ? (
            <p className="text-xs text-primary mt-1">Verifying account...</p>
          ) : accountName ? (
            <p className="text-xs text-green-600 font-medium mt-1">{accountName}</p>
          ) : null}
        </div>

        <button
          type="submit"
          disabled={loading || migrateLoading}
          className="w-full mt-4 bg-primary disabled:opacity-50 text-white font-medium py-2.5 rounded-md hover:opacity-90 transition-opacity"
        >
          {migrateLoading ? "Migrating..." : "Migrate"}
        </button>
      </form>
    </Dialog>
  );
}

export default MigrateModal;
